import { defineMessages } from "react-intl";
export default defineMessages({
    accountDeleted: {
        id: "common.accountDeleted",
        defaultMessage: "Your account has been successfully deleted.",
    },
    accountOnHold: {
        id: "common.accountOnHold",
        defaultMessage: "Your account connection has expired. Please reconnect to resume data updates.",
    },
    add: {
        id: "common.add",
        defaultMessage: "Add",
    },
    addAStation: {
        id: "common.addAStation",
        defaultMessage: "Add a station",
    },
    addToFavorites: {
        id: "common.addToFavorites",
        defaultMessage: "Add to favorites",
    },
    addYourOwnStation: {
        id: "common.addYourOwnStation",
        defaultMessage: "Add your own station",
    },
    alreadyPremium: {
        id: "common.alreadyPremium",
        defaultMessage: "You already have a premium account!",
    },
    alsoAvailableOn: {
        id: "common.alsoAvailableOn",
        defaultMessage: "Also available on:",
    },
    altitude: {
        id: "common.altitude",
        defaultMessage: "Altitude",
    },
    analysis: {
        id: "common.analysis",
        defaultMessage: "Analysis",
    },
    aroundMe: {
        id: "common.aroundMe",
        defaultMessage: "Around me",
    },
    articleCount: {
        id: "common.articleCount",
        defaultMessage: "{count, plural, one {# article} other {# articles}}",
    },
    articleNotFound: {
        id: "common.articleNotFound",
        defaultMessage: "Article Not Found",
    },
    articleNotFoundDescription: {
        id: "common.articleNotFoundDescription",
        defaultMessage: "The article you're looking for doesn't exist.",
    },
    average: {
        id: "common.average",
        defaultMessage: "Average",
    },
    averageOverThePeriod: {
        id: "common.averageOverThePeriod",
        defaultMessage: "Average over the period",
    },
    away: {
        id: "common.away",
        defaultMessage: "Away",
    },
    backToHelpCenter: {
        id: "common.backToHelpCenter",
        defaultMessage: "Back to Help Center",
    },
    backToHome: {
        id: "common.backToHome",
        defaultMessage: "Back to Home",
    },
    bad: {
        id: "common.bad",
        defaultMessage: "Bad",
    },
    batteryLevel: {
        id: "common.batteryLevel",
        defaultMessage: "Battery level",
    },
    bestValue: {
        id: "common.bestValue",
        defaultMessage: "Best Value",
    },
    billingDetailsIos: {
        id: "common.billingDetailsIos",
        defaultMessage: "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your App Store account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your App Store account at confirmation of your purchase and upon commencement of each renewal term.",
    },
    billingDetailsAndroid: {
        id: "common.billingDetailsAndroid",
        defaultMessage: "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your Google Play account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your Google Play account at confirmation of your purchase and upon commencement of each renewal term.",
    },
    boilerOn: {
        id: "common.boilerOn",
        defaultMessage: "Boiler ON",
    },
    browseByCategory: {
        id: "common.browseByCategory",
        defaultMessage: "Browse by Category",
    },
    calendarView: {
        id: "common.calendarView",
        defaultMessage: "Calendar view",
    },
    cancel: {
        id: "common.cancel",
        defaultMessage: "Cancel",
    },
    cannotBeEmpty: {
        id: "common.cannotBeEmpty",
        defaultMessage: "This field cannot be empty.",
    },
    cardDetails: {
        id: "common.cardDetails",
        defaultMessage: "Card details",
    },
    categoryNotFound: {
        id: "common.categoryNotFound",
        defaultMessage: "Category not found",
    },
    categoryNotFoundDescription: {
        id: "common.categoryNotFoundDescription",
        defaultMessage: "This category doesn't exist or has no articles.",
    },
    chartView: {
        id: "common.chartView",
        defaultMessage: "Chart view",
    },
    charts: {
        id: "common.charts",
        defaultMessage: "Charts",
    },
    clearRecentLocations: {
        id: "common.clearRecentLocations",
        defaultMessage: "Clear all",
    },
    close: {
        id: "common.close",
        defaultMessage: "Close",
    },
    comparison: {
        id: "common.comparison",
        defaultMessage: "Comparison",
    },
    currentDay: {
        id: "common.currentDay",
        defaultMessage: "Current day",
    },
    currentLocation: {
        id: "common.currentLocation",
        defaultMessage: "Current location",
    },
    currentObservations: {
        id: "common.currentObservations",
        defaultMessage: "Current observations",
    },
    currentRainEvent: {
        id: "common.currentRainEvent",
        defaultMessage: "Current rain event",
    },
    currentRate: {
        id: "common.currentRate",
        defaultMessage: "Current rate",
    },
    currentWeatherConditions: {
        id: "common.currentWeatherConditions",
        defaultMessage: "Current conditions",
    },
    customizeComparisonMetrics: {
        id: "common.customizeComparisonMetrics",
        defaultMessage: "Customize metrics",
    },
    customizeComparisonMetricsDescription: {
        id: "common.customizeComparisonMetricsDescription",
        defaultMessage: "Drag items to reorder your comparison metrics. Tap the eye icon to show or hide metrics.",
    },
    customizeDashboard: {
        id: "common.customizeDashboard",
        defaultMessage: "Customize",
    },
    customizeDashboardDescription: {
        id: "common.customizeDashboardDescription",
        defaultMessage: "Drag items to reorder your dashboard. Tap the eye icon to show or hide sections.",
    },
    customizedStationName: {
        id: "common.customizedStationName",
        defaultMessage: "Customized station name",
    },
    dailyForecast: {
        id: "common.dailyForecast",
        defaultMessage: "Daily forecast",
    },
    dashboard: {
        id: "common.dashboard",
        defaultMessage: "Dashboard",
    },
    delete: {
        id: "common.delete",
        defaultMessage: "Delete",
    },
    deleteAccount: {
        id: "common.deleteAccount",
        defaultMessage: "Delete your account",
    },
    deleteAccountConfirmation: {
        id: "common.deleteAccountConfirmation",
        defaultMessage: "Are you sure you want to delete your account? This action is irreversible.",
    },
    deleteAccountDescription: {
        id: "common.deleteAccountDescription",
        defaultMessage: "This action deletes your account and all your information. There is no going back.",
    },
    details: {
        id: "common.details",
        defaultMessage: "Details",
    },
    edit: {
        id: "common.edit",
        defaultMessage: "Edit",
    },
    editor: {
        id: "common.editor",
        defaultMessage: "Editor",
    },
    endTime: {
        id: "common.endTime",
        defaultMessage: "End time",
    },
    exploreWeatherMap: {
        id: "common.exploreWeatherMap",
        defaultMessage: "Explore Weather Map",
    },
    favoriteLocations: {
        id: "common.favoriteLocations",
        defaultMessage: "Favorites",
    },
    favoriteLocationsEmpty: {
        id: "common.favoriteLocationsEmpty",
        defaultMessage: "You can add up to 5 favorite locations.",
    },
    favoriteStations: {
        id: "common.favoriteStations",
        defaultMessage: "Favorite stations",
    },
    feedbackHelpsImprove: {
        id: "common.feedbackHelpsImprove",
        defaultMessage: "Your input helps us improve our help articles.",
    },
    filterStationDescription: {
        id: "common.filterStationDescription",
        defaultMessage: "Do not display stations with unreliable measures",
    },
    filterStationSourceDescription: {
        id: "common.filterStationSourceDescription",
        defaultMessage: "Select station providers that you want to display on the map",
    },
    filterStations: {
        id: "common.filterStations",
        defaultMessage: "Filter stations",
    },
    findStationsNearYou: {
        id: "common.findStationsNearYou",
        defaultMessage: "Find Stations Near You",
    },
    firmwareVersion: {
        id: "common.firmwareVersion",
        defaultMessage: "Firmware version",
    },
    exitFullscreen: {
        id: "common.exitFullscreen",
        defaultMessage: "Exit fullscreen",
    },
    forecast: {
        id: "common.forecast",
        defaultMessage: "Forecast",
    },
    fullscreen: {
        id: "common.fullscreen",
        defaultMessage: "Fullscreen",
    },
    forecastComparisonDescription: {
        id: "common.forecastComparisonDescription",
        defaultMessage: "Easily compare forecast model outputs from several sources",
    },
    forecastModelComparison: {
        id: "common.forecastModelComparison",
        defaultMessage: "Forecast model comparison",
    },
    forecastSources: {
        id: "common.forecastSources",
        defaultMessage: "Forecast sources",
    },
    freeAccount: {
        id: "common.freeAccount",
        defaultMessage: "Free account",
    },
    freeSubscription: {
        id: "common.freeSubscription",
        defaultMessage: "Free premium subscription",
    },
    freeTrialForPeriod: {
        id: "common.freeTrialForPeriod",
        defaultMessage: "Free trial for {period} days",
    },
    frequency: {
        id: "common.frequency",
        defaultMessage: "Frequency",
    },
    full: {
        id: "common.full",
        defaultMessage: "Full",
    },
    getStartedFree: {
        id: "common.getStartedFree",
        defaultMessage: "Get Started Free",
    },
    getUnlimitedAccess: {
        id: "common.getUnlimitedAccess",
        defaultMessage: "Get unlimited access to:",
    },
    good: {
        id: "common.good",
        defaultMessage: "Good",
    },
    help: {
        id: "common.help",
        defaultMessage: "Help",
    },
    helpCategoryAccount: {
        id: "common.helpCategoryAccount",
        defaultMessage: "Account",
    },
    helpCategoryBilling: {
        id: "common.helpCategoryBilling",
        defaultMessage: "Billing",
    },
    helpCategoryGettingStarted: {
        id: "common.helpCategoryGettingStarted",
        defaultMessage: "Getting Started",
    },
    helpCategoryProviders: {
        id: "common.helpCategoryProviders",
        defaultMessage: "Providers",
    },
    helpCategoryStations: {
        id: "common.helpCategoryStations",
        defaultMessage: "Stations",
    },
    helpCategoryTroubleshooting: {
        id: "common.helpCategoryTroubleshooting",
        defaultMessage: "Troubleshooting",
    },
    helpCenter: {
        id: "common.helpCenter",
        defaultMessage: "Help Center",
    },
    helpCenterDescription: {
        id: "common.helpCenterDescription",
        defaultMessage: "Find answers to common questions and learn how to get the most out of SmartMixin.",
    },
    hg: {
        id: "common.hg",
        defaultMessage: "Frost guard",
    },
    hidden: {
        id: "common.hidden",
        defaultMessage: "Hidden",
    },
    hiddenStations: {
        id: "common.hiddenStations",
        defaultMessage: "Hidden stations",
    },
    hiddenStationsDescription: {
        id: "common.hiddenStationsDescription",
        defaultMessage: "You can unhide a station by tapping the eye icon next to it.",
    },
    high: {
        id: "common.high",
        defaultMessage: "High",
    },
    home: {
        id: "common.home",
        defaultMessage: "Home",
    },
    homeConnectService: {
        id: "common.homeConnectService",
        defaultMessage: "Own a weather station? Connect your service",
    },
    homeInformation: {
        id: "common.homeInformation",
        defaultMessage: "Home information",
    },
    homeIntroduction: {
        id: "common.homeIntroduction",
        defaultMessage: "Start connecting your external accounts to enjoy SmartMixin features.",
    },
    homeSubtitle: {
        id: "common.homeSubtitle",
        defaultMessage: "Your weather, all in one place",
    },
    homeName: {
        id: "common.homeName",
        defaultMessage: "Home name",
    },
    horizon: {
        id: "common.horizon",
        defaultMessage: "Horizon",
    },
    horizonValue: {
        id: "common.horizonValue",
        defaultMessage: "up to {value} hours",
    },
    iDontKnowYet: {
        id: "common.iDontKnowYet",
        defaultMessage: "I don't know yet",
    },
    indoor: {
        id: "common.indoor",
        defaultMessage: "Indoor",
    },
    lastRainEvent: {
        id: "common.lastRainEvent",
        defaultMessage: "Last rain event",
    },
    lastUpdate: {
        id: "common.lastUpdate",
        defaultMessage: "Last update",
    },
    loading: {
        id: "common.loading",
        defaultMessage: "Loading",
    },
    location: {
        id: "common.location",
        defaultMessage: "Location",
    },
    locationAddedToFavorites: {
        id: "common.locationAddedToFavorites",
        defaultMessage: "Location added to favorites",
    },
    locationNotGranted: {
        id: "common.locationNotGranted",
        defaultMessage: "Location permission is not granted. Please allow access to your location in device settings.",
    },
    locationRemovedFromFavorites: {
        id: "common.locationRemovedFromFavorites",
        defaultMessage: "Location removed from favorites",
    },
    locations: {
        id: "common.locations",
        defaultMessage: "Locations",
    },
    low: {
        id: "common.low",
        defaultMessage: "Low",
    },
    manage: {
        id: "common.manage",
        defaultMessage: "Manage",
    },
    manageAccount: {
        id: "common.manageAccount",
        defaultMessage: "Manage account",
    },
    manageMySubscription: {
        id: "common.manageMySubscription",
        defaultMessage: "Manage my subscription",
    },
    manualBoost: {
        id: "common.manualBoost",
        defaultMessage: "Manual boost",
    },
    manualSetpointUntil: {
        id: "common.manualSetpointUntil",
        defaultMessage: "Manual setpoint until",
    },
    maxFavoriteLocationsReached: {
        id: "common.maxFavoriteLocationsReached",
        defaultMessage: "You can only have up to 5 favorite locations. Remove one to add another.",
    },
    measureToDisplay: {
        id: "common.measureToDisplay",
        defaultMessage: "Measure to display",
    },
    medium: {
        id: "common.medium",
        defaultMessage: "Medium",
    },
    meshSize: {
        id: "common.meshSize",
        defaultMessage: "Grid size",
    },
    minRead: {
        id: "common.minRead",
        defaultMessage: "{minutes} min read",
    },
    modifyFavoriteStations: {
        id: "common.modifyFavoriteStations",
        defaultMessage: "Modify favorite stations",
    },
    modifyFavoriteStationsDescription: {
        id: "common.modifyFavoriteStationsDescription",
        defaultMessage: "You can reorder your favorite stations by dragging them. You can also remove them from the list.",
    },
    moduleType: {
        id: "common.moduleType",
        defaultMessage: "Module type",
    },
    monthTotal: {
        id: "common.monthTotal",
        defaultMessage: "Month total",
    },
    more: {
        id: "common.more",
        defaultMessage: "More",
    },
    moreInformation: {
        id: "common.moreInformation",
        defaultMessage: "More information",
    },
    myLocation: {
        id: "common.myLocation",
        defaultMessage: "My location",
    },
    nearbyWeatherStations: {
        id: "common.nearbyWeatherStations",
        defaultMessage: "Nearby weather stations",
    },
    next: {
        id: "common.next",
        defaultMessage: "Next",
    },
    nextHours: {
        id: "common.nextHours",
        defaultMessage: "Next hours",
    },
    no: {
        id: "common.no",
        defaultMessage: "No",
    },
    noAccountNeeded: {
        id: "common.noAccountNeeded",
        defaultMessage: "No account needed",
    },
    noDataForThisPeriod: {
        id: "common.noDataForThisPeriod",
        defaultMessage: "No data for this period",
    },
    noLocationsFound: {
        id: "common.noLocationsFound",
        defaultMessage: "No locations found",
    },
    noNetatmoWeatherStationYet: {
        id: "common.noNetatmoWeatherStationYet",
        defaultMessage: "You don't have a Netatmo weather station yet.",
    },
    noOutdoorModule: {
        id: "common.noOutdoorModule",
        defaultMessage: "There is no functional outdoor module for this station.",
    },
    noStationsFound: {
        id: "common.noStationsFound",
        defaultMessage: "No Stations Found",
    },
    noThermostatYet: {
        id: "common.noThermostatYet",
        defaultMessage: "You dont' have a thermostat yet.",
    },
    noWeatherStation: {
        id: "common.noWeatherStation",
        defaultMessage: "No weather station",
    },
    noWeatherStationYet: {
        id: "common.noWeatherStationYet",
        defaultMessage: "You don't have a weather station yet.",
    },
    notNow: {
        id: "common.notNow",
        defaultMessage: "Not Now",
    },
    notPurchasedYet: {
        id: "common.notPurchasedYet",
        defaultMessage: "It seems this has not been purchased yet.",
    },
    numberOfActiveWarnings: {
        id: "common.numberOfActiveWarnings",
        defaultMessage: "{warning_count} active weather warnings",
    },
    openSettings: {
        id: "common.openSettings",
        defaultMessage: "Open Settings",
    },
    orChooseMonthly: {
        id: "common.orChooseMonthly",
        defaultMessage: "Or choose monthly:",
    },
    outdatedModule: {
        id: "common.outdatedModule",
        defaultMessage: "The data for this module is out of date.",
    },
    outdoor: {
        id: "common.outdoor",
        defaultMessage: "Outdoor",
    },
    outdoorTemperature: {
        id: "common.outdoorTemperature",
        defaultMessage: "Outdoor temperature",
    },
    pageNotFound: {
        id: "common.pageNotFound",
        defaultMessage: "Page Not Found",
    },
    pageNotFoundDescription: {
        id: "common.pageNotFoundDescription",
        defaultMessage: "The page you're looking for doesn't exist or has been moved.",
    },
    passwordUpdated: {
        id: "common.passwordUpdated",
        defaultMessage: "Password successfully updated.",
    },
    personalWeatherIntelligence: {
        id: "common.personalWeatherIntelligence",
        defaultMessage: "Your Personal Weather Intelligence",
    },
    premiumAccount: {
        id: "common.premiumAccount",
        defaultMessage: "Premium account",
    },
    premiumDescription: {
        id: "common.premiumDescription",
        defaultMessage: "Premium subscription unlocks many additional features such as advanced weather analysis, chart comparisons, regional forecast models and lots more.",
    },
    premiumFeatureAlerts: {
        id: "common.premiumFeatureAlerts",
        defaultMessage: "Weather Alerts",
    },
    premiumFeatureAnalysis: {
        id: "common.premiumFeatureAnalysis",
        defaultMessage: "Advanced Weather Analysis",
    },
    premiumFeatureCharts: {
        id: "common.premiumFeatureCharts",
        defaultMessage: "Chart Comparisons",
    },
    premiumFeatureExport: {
        id: "common.premiumFeatureExport",
        defaultMessage: "Data Export",
    },
    premiumFeatureForecast: {
        id: "common.premiumFeatureForecast",
        defaultMessage: "Regional Forecast Models",
    },
    premiumFeatureNotification: {
        id: "common.premiumFeatureNotification",
        defaultMessage: "Status Bar Widget",
    },
    premiumFeatureTitle: {
        id: "common.premiumFeatureTitle",
        defaultMessage: "Premium Feature",
    },
    premiumFeatureWidgets: {
        id: "common.premiumFeatureWidgets",
        defaultMessage: "Home Screen Widgets",
    },
    pressureSummary: {
        id: "common.pressureSummary",
        defaultMessage: "Pressure summary",
    },
    previous: {
        id: "common.previous",
        defaultMessage: "Previous",
    },
    previousHours: {
        id: "common.previousHours",
        defaultMessage: "Previous hours",
    },
    profileUpdated: {
        id: "common.profileUpdated",
        defaultMessage: "Profile successfully updated.",
    },
    purchasedNetatmoPro: {
        id: "common.purchasedNetatmoPro",
        defaultMessage: "You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features.",
    },
    rain: {
        id: "common.rain",
        defaultMessage: "Rain",
    },
    rainEvents: {
        id: "common.rainEvents",
        defaultMessage: "Rain events",
    },
    rainRadar: {
        id: "common.rainRadar",
        defaultMessage: "Rain radar",
    },
    rainRadarDescription: {
        id: "common.rainRadarDescription",
        defaultMessage: "Display rain radar overlay on the map",
    },
    rainSummary: {
        id: "common.rainSummary",
        defaultMessage: "Rain summary",
    },
    rainfallMeasurement: {
        id: "common.rainfallMeasurement",
        defaultMessage: "Rainfall measurement",
    },
    range: {
        id: "common.range",
        defaultMessage: "Range",
    },
    recentLocations: {
        id: "common.recentLocations",
        defaultMessage: "Recent",
    },
    recentLocationsEmpty: {
        id: "common.recentLocationsEmpty",
        defaultMessage: "You recent history is empty.",
    },
    recentStations: {
        id: "common.recentStations",
        defaultMessage: "Recent stations",
    },
    relatedArticles: {
        id: "common.relatedArticles",
        defaultMessage: "Related Articles",
    },
    relay: {
        id: "common.relay",
        defaultMessage: "Relay",
    },
    removeFromFavorites: {
        id: "common.removeFromFavorites",
        defaultMessage: "Remove from favorites",
    },
    renameSensors: {
        id: "common.renameSensors",
        defaultMessage: "Rename sensors",
    },
    manageSensors: {
        id: "common.manageSensors",
        defaultMessage: "Manage sensors",
    },
    manageSensorsDescription: {
        id: "common.manageSensorsDescription",
        defaultMessage: "Drag items to reorder sensors. Tap the eye icon to show or hide sensors. Tap a name to rename it.",
    },
    hiddenSensors: {
        id: "common.hiddenSensors",
        defaultMessage: "Hidden sensors",
    },
    resetZoom: {
        id: "common.resetZoom",
        defaultMessage: "Reset Zoom",
    },
    restorePurchase: {
        id: "common.restorePurchase",
        defaultMessage: "Restore purchase",
    },
    room: {
        id: "common.room",
        defaultMessage: "Room",
    },
    rooms: {
        id: "common.rooms",
        defaultMessage: "Rooms",
    },
    savingsPercent: {
        id: "common.savingsPercent",
        defaultMessage: "Save {percent}%",
    },
    searchArticles: {
        id: "common.searchArticles",
        defaultMessage: "Search articles...",
    },
    searchForALocation: {
        id: "common.searchForALocation",
        defaultMessage: "Search for a location...",
    },
    searchForLocation: {
        id: "common.searchForLocation",
        defaultMessage: "Search for a location",
    },
    searchForWeatherStation: {
        id: "common.searchForWeatherStation",
        defaultMessage: "Search for a weather station",
    },
    searchResults: {
        id: "common.searchResults",
        defaultMessage: "Search results",
    },
    searchResultsEmpty: {
        id: "common.searchResultsEmpty",
        defaultMessage: "No results found.",
    },
    searchStationsDescription: {
        id: "common.searchStationsDescription",
        defaultMessage: "Enter a city, address, or place name to find weather stations nearby.",
    },
    searchStationsHint: {
        id: "common.searchStationsHint",
        defaultMessage: "Use the search bar above to discover weather stations in any location around the world.",
    },
    selectStationForComparison: {
        id: "common.selectStationForComparison",
        defaultMessage: "Select a station to compare with",
    },
    selectWeatherForecastProvider: {
        id: "common.selectWeatherForecastProvider",
        defaultMessage: "Please choose a weather provider",
    },
    serialNumber: {
        id: "common.serialNumber",
        defaultMessage: "Serial number",
    },
    share: {
        id: "common.share",
        defaultMessage: "Share",
    },
    shareOutdoorMeasures: {
        id: "common.shareOutdoorMeasures",
        defaultMessage: "Share your outdoor measures",
    },
    shareOutdoorMeasuresDescription: {
        id: "common.shareOutdoorMeasuresDescription",
        defaultMessage: "Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared.",
    },
    shareYourWeather: {
        id: "common.shareYourWeather",
        defaultMessage: "Share your weather",
    },
    signalStrength: {
        id: "common.signalStrength",
        defaultMessage: "Signal strength",
    },
    skip: {
        id: "common.skip",
        defaultMessage: "Skip",
    },
    snow: {
        id: "common.snow",
        defaultMessage: "Snow",
    },
    smartThermostat: {
        id: "common.smartThermostat",
        defaultMessage: "Smart thermostat",
    },
    smartValve: {
        id: "common.smartValve",
        defaultMessage: "Smart valve",
    },
    start: {
        id: "common.start",
        defaultMessage: "Start",
    },
    startFreeTrial: {
        id: "common.startFreeTrial",
        defaultMessage: "Start Free Trial",
    },
    startTime: {
        id: "common.startTime",
        defaultMessage: "Start time",
    },
    station: {
        id: "common.station",
        defaultMessage: "station",
    },
    stationAddedToFavorites: {
        id: "common.stationAddedToFavorites",
        defaultMessage: "Station added to favorites",
    },
    stationComparison: {
        id: "common.stationComparison",
        defaultMessage: "Station comparison",
    },
    stationComparisonDescription: {
        id: "common.stationComparisonDescription",
        defaultMessage: "Compare historical weather data with another station",
    },
    stationInformation: {
        id: "common.stationInformation",
        defaultMessage: "Station information",
    },
    stationName: {
        id: "common.stationName",
        defaultMessage: "Station name",
    },
    stationObservationsDescription: {
        id: "common.stationObservationsDescription",
        defaultMessage: "Display the latest observations from weather stations",
    },
    stationRemovedFromFavorites: {
        id: "common.stationRemovedFromFavorites",
        defaultMessage: "Station removed from favorites",
    },
    stationType: {
        id: "common.stationType",
        defaultMessage: "Station type",
    },
    stations: {
        id: "common.stations",
        defaultMessage: "stations",
    },
    stationsNear: {
        id: "common.stationsNear",
        defaultMessage: "Stations near",
    },
    statusOffline: {
        id: "common.statusOffline",
        defaultMessage: "Offline",
    },
    statusOnline: {
        id: "common.statusOnline",
        defaultMessage: "Online",
    },
    statusStale: {
        id: "common.statusStale",
        defaultMessage: "Stale",
    },
    statusSyncing: {
        id: "common.statusSyncing",
        defaultMessage: "Syncing",
    },
    subscribeNow: {
        id: "common.subscribeNow",
        defaultMessage: "Subscribe now - no trial",
    },
    sumOverThePeriod: {
        id: "common.sumOverThePeriod",
        defaultMessage: "Cumulated over the period",
    },
    switchToPremium: {
        id: "common.switchToPremium",
        defaultMessage: "Switch to SmartMixin Premium",
    },
    temperatureShort: {
        id: "common.temperatureShort",
        defaultMessage: "Temp.",
    },
    temperatureSummary: {
        id: "common.temperatureSummary",
        defaultMessage: "Temperature summary",
    },
    thankYouForFeedback: {
        id: "common.thankYouForFeedback",
        defaultMessage: "Thank you for your feedback!",
    },
    thenPrice: {
        id: "common.thenPrice",
        defaultMessage: "then {price}",
    },
    timeSelection: {
        id: "common.timeSelection",
        defaultMessage: "Time selection",
    },
    timezone: {
        id: "common.timezone",
        defaultMessage: "Timezone",
    },
    totalDuration: {
        id: "common.totalDuration",
        defaultMessage: "Total duration",
    },
    tryAnotherLocation: {
        id: "common.tryAnotherLocation",
        defaultMessage: "We couldn't find any weather stations near this location. Try searching for a different area.",
    },
    unknown: {
        id: "common.unknown",
        defaultMessage: "Unknown",
    },
    untilChanged: {
        id: "common.untilChanged",
        defaultMessage: "Until changed",
    },
    untilTime: {
        id: "common.untilTime",
        defaultMessage: "Until {time}",
    },
    upgrade: {
        id: "common.upgrade",
        defaultMessage: "Upgrade",
    },
    upgradeRequiredIos: {
        id: "common.upgradeRequiredIos",
        defaultMessage: "An upgrade of your application is required. Visit the App Store to upgrade.",
    },
    upgradeRequiredAndroid: {
        id: "common.upgradeRequiredAndroid",
        defaultMessage: "An upgrade of your application is required. Visit Google Play to upgrade.",
    },
    validEmail: {
        id: "common.validEmail",
        defaultMessage: "A valid email address is required.",
    },
    validate: {
        id: "common.validate",
        defaultMessage: "Validate",
    },
    very_low: {
        id: "common.very_low",
        defaultMessage: "Very low",
    },
    visitNetatmoWebsite: {
        id: "common.visitNetatmoWebsite",
        defaultMessage: "Visit Netatmo website",
    },
    wasArticleHelpful: {
        id: "common.wasArticleHelpful",
        defaultMessage: "Was this article helpful?",
    },
    weatherCondition: {
        id: "common.weatherCondition",
        defaultMessage: "Weather condition",
    },
    weatherForecastModels: {
        id: "common.weatherForecastModels",
        defaultMessage: "Weather forecast models",
    },
    weatherIntelligencePlatform: {
        id: "common.weatherIntelligencePlatform",
        defaultMessage: "The Weather Intelligence Platform",
    },
    weatherMap: {
        id: "common.weatherMap",
        defaultMessage: "Weathermap",
    },
    weatherMapMetaDescription: {
        id: "common.weatherMapMetaDescription",
        defaultMessage: "SmartMixin provides interactive weather and radar maps for weather conditions for locations worldwide.",
    },
    weatherObservations: {
        id: "common.weatherObservations",
        defaultMessage: "Weather observations",
    },
    weatherStation: {
        id: "common.weatherStation",
        defaultMessage: "Weather station",
    },
    weatherStations: {
        id: "common.weatherStations",
        defaultMessage: "Weather stations",
    },
    weatherflowNCRain: {
        id: "common.weatherflowNCRain",
        defaultMessage: "NC Rain (Nearcast Rain)",
    },
    weatherflowNCRainDescription: {
        id: "common.weatherflowNCRainDescription",
        defaultMessage: "NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level",
    },
    welcome: {
        id: "common.welcome",
        defaultMessage: "Welcome to SmartMixin!",
    },
    whenBackHome: {
        id: "common.whenBackHome",
        defaultMessage: "When will you be back home?",
    },
    wifiStrength: {
        id: "common.wifiStrength",
        defaultMessage: "WiFi strength",
    },
    wind: {
        id: "common.wind",
        defaultMessage: "Wind",
    },
    windMeasurement: {
        id: "common.windMeasurement",
        defaultMessage: "Wind measurement",
    },
    windSpeed: {
        id: "common.windSpeed",
        defaultMessage: "Wind speed",
    },
    windSummary: {
        id: "common.windSummary",
        defaultMessage: "Wind summary",
    },
    yearToDate: {
        id: "common.yearToDate",
        defaultMessage: "Year to Date",
    },
    yes: {
        id: "common.yes",
        defaultMessage: "Yes",
    },
});
